import { useLingui } from '@lingui/react/macro'
import { GraphQL } from '@guestgoodie/graphql'

import Input from '@/components/ui/Input'
import * as Form from '@/features/form'
import { Editor } from '@/features/editor'
import { GalleryUpload } from '@/features/files'
import { FormData } from '../../hooks/useGoodieForm'

export function CommonFields() {
  const { t } = useLingui()

  return (
    <div className="relative flex w-full flex-col gap-6 pt-4">
      <Form.Field
        name="name"
        label={`${t`Name (isn't shown to Guests)`}*`}
        rules={{
          maxLength: {
            value: 255,
            message: t`Can't be longer than 255 characters.`
          },
          validate: {
            required: Form.Validations.requiredWithTrimValidation(
              t`This field is required`
            )
          }
        }}
      >
        {({ renderProps: { onChange, ...props } }) => (
          <Input
            onChange={event => {
              const newName = event.target.value

              onChange(newName)
            }}
            type="text"
            placeholder={t({
              comment: 'Placeholder for the Name input on the Goodie',
              message: 'e.g.: Hand-Massage 90mins'
            })}
            {...props}
          />
        )}
      </Form.Field>
      <Form.Field
        name="title"
        label={`${t`Title`}*`}
        rules={{
          maxLength: {
            value: 255,
            message: t`Can't be longer than 255 characters.`
          },
          validate: {
            required: Form.Validations.requiredWithTrimValidation(
              t`This field is required`
            )
          }
        }}
      >
        {({ renderProps: { onChange, ...props } }) => (
          <Input
            onChange={event => onChange(event.target.value)}
            type="text"
            placeholder={t({
              comment: 'Placeholder for the Title Input on the Goodie',
              message: 'e.g.: Hand-Massage'
            })}
            {...props}
          />
        )}
      </Form.Field>
      <Form.SpecificData<GraphQL.GoodieType> name="type">
        {type => {
          if (type === GraphQL.GoodieType.Message) return null

          return (
            <Form.Field name="description" label={t`Description`}>
              {({ renderProps: { value, ...props } }) => (
                <Editor
                  placeholder={t`More information for the guest about the promotion`}
                  markdown={value}
                  {...props}
                />
              )}
            </Form.Field>
          )
        }}
      </Form.SpecificData>
      <Form.SpecificData<GraphQL.GoodieType> name="type">
        {type => {
          // Message type gallery is managed differently, since they only have one message
          if (type === GraphQL.GoodieType.Message) return null

          return (
            <>
              <Form.Field<FormData>
                name="files"
                label={t`Gallery`}
                description={t({
                  comment: 'Description of the Gallery Field for the Goodie',
                  message:
                    "Goodies that don't have Images/Videos can't be shown on the Feed."
                })}
              >
                {({
                  locale,
                  isDefaultLocale,
                  renderProps: { value, ...props }
                }) => (
                  <GalleryUpload
                    files={value}
                    accept="image/*,video/*"
                    locale={locale}
                    isDefaultLocale={isDefaultLocale}
                    {...props}
                  />
                )}
              </Form.Field>
            </>
          )
        }}
      </Form.SpecificData>
    </div>
  )
}
